import React, { useEffect, useState } from "react";
import Loader from "../../general/Loader";
import { getLink, toast } from "../../../utils/helpers";
import Modal from "../../general/Modal";
import { apiRequest } from "../../../hooks/apiRequest";
import { request } from "../../../utils/request";

const Reset = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [conteoEmpleado, setConteoEmpleado] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const procesar = async () => {
        setLoading(true);

        closeModal();

        const response = await apiRequest(null, 'ausencias/reset', 'POST');

        if (response.success) toast("Contador de días pendientes de vacaciones de todos los empleados fue reiniciado.");
        else toast("Error al ejecutando el proceso", "'error'"); 

        setLoading(false);
    };

    const obtenerConteoEmpleados = async () => {
        const response = await request('reportes/empleados/conteo');

        setConteoEmpleado(response.data ?? 0);
    };

    useEffect(() => {
        obtenerConteoEmpleados();
    }, []);

    return <>
        <div className="container-fluid">
            <div className="container mt-3">
                <div className="card border-warning">
                    <div className="card-header bg-warning text-dark">
                    <h2 className="mb-0">
                        <i className="fas fa-exclamation-triangle mr-2"></i>
                        Reiniciar contador de Vacaciones
                    </h2>
                    </div>

                    <div className="card-body">
                        <p>
                            Esta funcionalidad <strong>reinicia el contador de días pendientes de vacaciones </strong>
                            tomando como referencia la <strong>fecha actual</strong>, conforme a lo establecido
                            en el <strong>Código de Trabajo de la República Dominicana</strong>.
                        </p>

                        <ul className="my-2 mx-5">
                            <li><strong>5 Meses:</strong> 6 Días</li>
                            <li><strong>6 Meses:</strong> 7 Días</li>
                            <li><strong>7 Meses:</strong> 8 Días</li>
                            <li><strong>9 Meses:</strong> 10 Días</li>
                            <li><strong>10 Meses:</strong> 11 Días</li>
                            <li><strong>11 Meses:</strong> 12 Días</li>
                            <li><strong>1 Año o más:</strong> 14 Días</li>
                        </ul>

                        <p>
                            El proceso se aplicará a <strong>todos los empleados de la sucursal actual</strong>.
                            <br/> <span className="mr-2">Total empleados:</span>
                            {conteoEmpleado !== false ? <strong>{conteoEmpleado}</strong> : <Loader type="small"></Loader>}
                        </p>

                        <div className="my-2 alert alert-danger">
                            <strong>Importante: </strong>  
                            Una vez ejecutado este proceso, <u>no podrá revertirse de forma automática</u>.
                            Cualquier corrección deberá realizarse <strong>manualmente y de manera individual
                            para cada empleado</strong>.
                        </div>

                        <div className="text-right mt-3">
                            <button className="btn btn-danger" onClick={openModal}>
                                {loading ? <Loader type="small"/> : <span>Reiniciar Contador</span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal
            title='Reiniciar contador de vacaciones'
            show={showModal}
            callback={procesar}
            acceptText="Continuar"
            toggle={closeModal}>
            ¿Seguro que deseas reiniciar el contador de vacaciones de todos los empleados?
        </Modal>
    </>;
};

export default Reset;